import { themeRawValues } from '@/utils/styleUtils';

/**
 * Returns the hex color for a bar chart segment, using the same palette and index formula
 * as the Recharts bar chart. Both the chart bars and any legend must use this function to
 * stay in sync.
 */
export const getBarChartColor = (index: number, totalCount: number): string => {
  const chartPalette = themeRawValues.colors.chartColors;
  const colorSlot = (index + 1) % (totalCount + 1);
  const paletteKey = `color${colorSlot}` as keyof typeof chartPalette;
  return chartPalette[paletteKey] ?? chartPalette.color1;
};
